import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
  margin-left: 5px;
  margin-right: 5px;
`;

export const Title = styled.div`
  align-self: center;
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 33px;
  color: #073d59;
`;

export const QuestionsContainer = styled.div`
  height: 100%;
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SliderContainer = styled.div``;

export const SliderTitle = styled.div`
  margin: 5px;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #073d59;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const SliderFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SliderFooterText = styled.div`
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #798089;
`;

export const ContinueButton = styled.button`
  width: 100%;
  min-height: 56px;
  border-radius: 10px;
  background-color: #073d59;
  align-items: center;
  justify-content: center;
  align-self: center;
  flex-direction: row;
  cursor: pointer;
`;

export const ContinueButtonText = styled.div`
  font-size: 18px;
  font-family: 'Mulish';
  color: white;
`;
